import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { ListeComponent } from 'src/app/liste/liste.component';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
import { RechercheComponent } from 'src/app/recherche/recherche.component';
import { el } from 'date-fns/locale';
import { TarifService } from './tarif.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tarif-reservation',
  templateUrl: './tarif-reservation.component.html',
  styleUrls: ['./tarif-reservation.component.scss'],
})
export class TarifReservationComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    private dateService: DateService,
    public router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private tarifService: TarifService,
    private datePipe: DatePipe
  ) {
    this.router.events.subscribe((val: any) => {
      this.route.params.subscribe((params) => {
        this.Tiers_Code = params['param'];
        this.Tiers_RS = params['tiersName'];
      });
    });
  }

  @ViewChild(RechercheComponent, { static: false })
  public fournisseurComponent: RechercheComponent;

  @ViewChild('frmAjout', { static: false }) frmAjout;
  @ViewChild('frmDupliquate', { static: false }) frmDupliquate;
  @ViewChild('frmPreviewMAJtarif', { static: false }) frmPreviewMAJtarif;
  @ViewChild('frmPreviewImportTarifs', { static: false })
  frmPreviewImportTarifs;
  @ViewChild('frmAlertDup', { static: false }) frmAlertDup;
  @ViewChild('listeConmponent', { static: false })
  listeConmponent: ListeComponent;
  @ViewChild('listeDetailConmponent', { static: false })
  listeDetailConmponent: ListeComponent;
  exist: boolean = true;
  listeTarifs = [];
  listeType = [];
  columnsReservation;
  columnsReservationDetail;
  date_Debut: Date;
  date_Fin: Date;
  listeTarifsDetail = [];
  listIndColl = ['IND', 'COLL'];
  dsTarif;
  isValid = true;
  listBtn = [
    // {name:"consulter",class:"colorGreen",text:"Consulter",disabled : false,icon:"search"},
    {
      name: 'dupliquer',
      class: 'colorRed',
      text: 'Dupliquer',
      disabled: false,
      icon: 'content_copy',
    },
    {
      name: 'ajouter',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifier',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
    // {
    //   name: 'majTarif',
    //   class: 'colorGray',
    //   text: 'MAJ Tarif',
    //   disabled: false,
    //   icon: 'update',
    // },
  ];
  ngOnInit(): void {
    this.date_Fin = new Date();
    this.date_Debut = new Date('01-01-2020');
    //this.date_Debut.setDate(this.date_Debut.getDate() - 7);
    this.getColonneReservation();
    // this.getcolumnsReservationDetail();
    this.getDsTarif();
    this.initGlobalValues();

    this.getListeTarifReservation();
  }

  initGlobalValues() {
    this.route.queryParams.subscribe((params) => {
      if (params.code_fournisseur) {
        this.generalService
          .rechercheTable2('batfour1')
          .subscribe((res: any) => {
            this.Tiers_Code = params.code_fournisseur;
            this.Tiers_RS = res.find(
              (fournisseur) => fournisseur.Tiers_code == params.code_fournisseur
            ).Tiers_RS;
            console.log(this.Tiers_RS);
            this.getListeTarifReservation();
          });
      } else {
        this.getListeTarifReservation(
          this.date_Debut,
          new Date(this.date_Fin.setDate(this.date_Debut.getDate() + 365))
        );
      }
    });
  }
  TravelTarif;
  getDsTarif() {
    this.generalService.getDS('TravelTarif').subscribe((res) => {
      console.log(res);
      this.dsTarif = res;
      this.TravelTarif = this.dsTarif.TravelTarif[0];
    });
  }
  columnsTarifApercu;
  getColonneReservation() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=API_Tarif')
      .subscribe((data) => {
        if (data && data.TableRD.length > 0) this.columnsReservation = data;
        console.log(this.columnsReservation.TableRD);
        this.columnsTarifApercu = this.columnsReservation.TableRD.slice(
          1,
          this.columnsReservation.TableRD.length - 1
        );
      });
  }
  getcolumnsReservationDetail() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=travelD')
      .subscribe((data) => {
        if (data && data.TableRD.length > 0)
          this.columnsReservationDetail = data;
      });
  }
  getListeTarifReservation(dateDebParam?, dateFinParam?) {
    this.Tiers_Code = !this.Tiers_Code ? '' : this.Tiers_Code;
    var param = '';
    if (this.date_Debut && this.date_Fin && !dateDebParam && !dateFinParam) {
      param =
        this.dateService.setFormatDateRechercheServer(this.date_Debut) +
        ',' +
        this.dateService.setFormatDateRechercheServer(this.date_Fin) +
        ',' +
        this.Tiers_Code;
    }
    if (dateDebParam && dateFinParam) {
      param =
        this.dateService.setFormatDateRechercheServer(dateDebParam) +
        ',' +
        this.dateService.setFormatDateRechercheServer(dateFinParam) +
        ',' +
        this.Tiers_Code;
    }

    if (param)
      this.generalService
        .rechercheTable2('API_Tarif', param)
        .subscribe((res: any) => {
          console.log(res);
          this.listeTarifs = res;
          this.listeTarifs.forEach((tarif) => {
            const Type_TarifDecoy = tarif.Type_Tarif; // Save the original value
            tarif.Type_TarifDecoy = Type_TarifDecoy; // Add it as a new property
          });

          if (this.listeTarifs.length == 0) {
            this.generalService.dialogSuccess(
              'pas de tarifs disponible!',
              false
            );
          } else {
            const tierCodes = this.listeTarifs.map((tarif) => tarif.Tiers_code);
            if (tierCodes)
              this.generalService
                .rechercheTable2('API_Listetype1', tierCodes)
                .subscribe((res: any) => {
                  console.log(res);

                  const tarifTextMap = new Map();
                  res.forEach((typtarif) => {
                    tarifTextMap.set(typtarif.value, typtarif.text);
                  });

                  const updatedTarifs = this.listeTarifs.map((tarif) => {
                    const tarifText = tarifTextMap.get(tarif.Type_Tarif);
                    if (tarifText) {
                      return { ...tarif, Type_Tarif: tarifText };
                    }
                    return tarif;
                  });

                  // Assign the updatedTarifs back to listeTarifs
                  this.listeTarifs = updatedTarifs;

                  // Trigger change detection to update the view
                  this.changeDetectorRef.detectChanges();
                });
            console.log(this.listeTarifs);
          }
        });
  }

  getListeStandars() {
    this.generalService.rechercheTable2('Api_travelS').subscribe(
      (data: any) => {
        console.log(data);

        this.listeTarifs = data;
      },
      () => {
        this.generalService.dialogSuccess('pas de donnée disponible', false);
      }
    );
  }
  Toevent;
  openDialogueAlertDup(event) {
    this.Toevent = event;
    this.generalService.dialog.open(this.frmAlertDup, {
      width: '35vw',
      height: '30vh',
      disableClose: true,
    });
  }

  isModifTarif;
  disableBtnValidTarif = false;
  TarifCode;
  Tiers_Categorie;
  openDialogAjouterOuModifier(event?, isModif?) {
    if (isModif) {
      this.isModifTarif = isModif;
      this.disableBtnValidTarif = true;
      console.log(event);
      this.generalService
        .getDS('TravelTarif', event.Tarif_Code)
        .subscribe((res) => {
          console.log(res);
          this.dsTarif = res;

          this.TravelTarif = this.dsTarif.TravelTarif[0];
          this.TarifCode = this.TravelTarif.Tarif_Code;
          this.Tiers_Categorie = this.TravelTarif.Tiers_Categorie;
          // this.date_Debut = this.TravelTarif.Date_Deb
          // this.date_Fin=this.TravelTarif.Date_Fin
          this.isValid = this.TravelTarif.Valide == 1 ? true : false;

          this.generalService
            .rechercheTable2('batfour1')
            .subscribe((res: any) => {
              this.Tiers_RS = res.find(
                (fournisseur) =>
                  fournisseur.Tiers_code == this.TravelTarif.Tiers_code
              ).Tiers_RS;
              console.log(this.Tiers_RS);
            });

          if (this.TravelTarif.Tiers_code)
            this.generalService
              .rechercheTable2('API_Listetype1', this.TravelTarif.Tiers_code)
              .subscribe((res: any) => {
                console.log(res);
                console.log(this.TravelTarif);

                this.Tarif_Text = res.find(
                  (typtarif) => typtarif.value == this.TravelTarif.Type_Tarif
                )?.text;
                console.log(this.Tarif_Text);
              });
        });
    } else {
      this.disableBtnValidTarif = false;
      this.Tiers_RS = null;
      this.Tiers_Code = null;
      this.Tiers_Categorie = null;
      this.Tarif_Value = null;
      this.Tarif_Text = null;
      this.TravelTarif.Date_Deb = this.date_Debut;
      this.TravelTarif.Date_Fin = this.date_Fin;
      this.TravelTarif.Groupe_Max = 1000;
      this.TravelTarif.Groupe_Min = 1;

      this.TravelTarif.Accompagnant = 0;
      this.TravelTarif.Chauffeur = 0;
      this.TravelTarif.Guide = 0;

      this.TravelTarif.TVA = 0;
      this.TravelTarif.Marge = 0;

      this.TravelTarif.Tarif_Code = this.tarifService.getNextTarifCode(
        this.tarifService.listeAllTarifs
      );
    }
    this.generalService.dialog.open(this.frmAjout, {
      disableClose: true,
    });
  }

  openDialogPreviewMajTarif() {
    this.generalService.dialog.open(this.frmPreviewMAJtarif, {
      maxHeight: '100vh',
      maxWidth: '90vw',
    });
  }

  openDialogPreviewImportedTraifs() {
    this.generalService.dialog.open(this.frmPreviewImportTarifs, {
      maxHeight: '100vh',
      maxWidth: '96vw',
    });
  }

  MargeTarif;
  listeTarifsPreview;
  miseAjourTarifs() {
    if (this.listeTarifs.length != 0) {
      this.listeTarifsPreview = this.listeTarifs.filter((e) => e.Valide != 0);
      this.listeTarifsPreview.forEach((lgTarif) => {
        lgTarif.Tarif_Code = null;
        lgTarif.U_timestamp = null;
        lgTarif.Type_Tarif = lgTarif.Type_TarifDecoy;
        lgTarif.Date_Deb = this.ajouterAnneeAuDate(lgTarif.Date_Deb);
        lgTarif.Date_Fin = this.ajouterAnneeAuDate(lgTarif.Date_Fin);
        //Ancien MAJ Tarif en pourcentage
        //lgTarif.Tarif=this.MargeTarif?lgTarif.Tarif*((this.MargeTarif/100)+1):lgTarif.Tarif
        lgTarif.Tarif = this.MargeTarif
          ? lgTarif.Tarif + this.MargeTarif
          : lgTarif.Tarif;
      });
      console.log(this.listeTarifsPreview);
      this.getListeTarifReservation();
      this.openDialogPreviewMajTarif();
    } else
      this.generalService.dialogSuccess(
        'pas de données disponibles !! veuillez filtrer des tarifs',
        false
      );
  }

  ajouterAnneeAuDate(date) {
    var dateServ = new Date(date);
    var dateToreturn = dateServ.setDate(dateServ.getDate() + 365);
    return new Date(dateToreturn);
  }

  Tiers_Code = '';
  Tiers_RS;
  blurFournisseur(event) {
    console.log(event);
    this.generalService.rechercheTable2('batfour1').subscribe((res: any) => {
      this.Tiers_RS = res.find(
        (fournisseur) => fournisseur.Tiers_code == event
      )?.Tiers_RS;
      console.log(this.Tiers_RS);

      var fournisseur = res.find(
        (fournisseur) => fournisseur.Tiers_code == event
      );
      this.Tiers_Code = fournisseur?.Tiers_code;
      console.log(this.Tiers_Code);
    });
  }

  Tarif_Value;
  Tarif_Text;
  blurTypeTarif(event) {
    console.log(event);
    if (this.Tiers_Code)
      this.generalService
        .rechercheTable2('API_Listetype1', this.Tiers_Code)
        .subscribe((res: any) => {
          console.log(res);

          this.Tarif_Text = res.find(
            (typtarif) =>
              typtarif.value == event.value &&
              typtarif.TravelD_TypeEvent == event.TravelD_TypeEvent
          ).text;
          console.log(this.Tarif_Text);

          var typtarif = res.find(
            (typtarif) =>
              typtarif.value == event.value &&
              typtarif.TravelD_TypeEvent == event.TravelD_TypeEvent
          );
          this.Tarif_Value = typtarif.value;
          console.log(this.Tarif_Value);
        });
  }

  ajouterOuModifierLigneTarif() {
    if (!this.isModifTarif) {
      const TravelTarif = this.dsTarif.TravelTarif[0];

      // TravelTarif.Date_Deb = new Date(
      //   this.date_Debut.setDate(this.date_Debut.getDate() + 1)
      // );
      // TravelTarif.Date_Fin = this.date_Fin;
      TravelTarif.Tiers_code = this.Tiers_Code;
      TravelTarif.Type_Tarif = this.Tarif_Value;
      TravelTarif.Valide = this.isValid ? 1 : 0;

      console.log(this.dsTarif);

      if (TravelTarif.Tarif_Code)
        this.generalService.postDs(this.dsTarif).subscribe((res) => {
          console.log('tarif enregistrer');
          this.date_Debut.setDate(this.date_Debut.getDate() - 1);
          this.close();
          this.getDsTarif();
          this.getListeTarifReservation();
          this.updateDataAfterActions();

          this.generalService.dialogSuccess('Tarif Enregistrée!', true);
        });
      else
        this.generalService.dialogSuccess(
          'veuillez entrer le code tarif!',
          false
        );
    } else {
      const TravelTarif = this.TravelTarif;

      // TravelTarif.Date_Deb=new Date(this.date_Debut.setDate(this.date_Debut.getDate() + 1));
      // TravelTarif.Date_Fin=this.date_Fin
      TravelTarif.Tiers_code = this.Tiers_Code
        ? this.Tiers_Code
        : this.TravelTarif.Tiers_code;
      TravelTarif.Tiers_Categorie = this.Tiers_Categorie
        ? this.Tiers_Categorie
        : this.TravelTarif.Tiers_Categorie;
      TravelTarif.Type_Tarif =
        this.Tarif_Value || this.Tarif_Value == 0
          ? this.Tarif_Value
          : this.TravelTarif.Type_Tarif;
      TravelTarif.Valide = this.isValid ? 1 : 0;
      TravelTarif.Tarif_MAJ = 0;
      //TravelTarif.U_timestamp = null;
      console.log(this.dsTarif);

      this.generalService.postDs(this.dsTarif).subscribe((res) => {
        console.log('tarif enregistrer');
        // this.date_Debut.setDate(this.date_Debut.getDate() - 1)
        //this.putTarifValidite(this.TarifCode);
        this.close();
        this.getDsTarif();
        this.getListeTarifReservation();
        this.updateDataAfterActions();
        this.generalService.dialogSuccess('Tarif Enregistrée!', true);
      });
    }
  }

  putTarifValidite(Tarif_Code) {
    var TarifToModifValide;
    this.generalService.getDS('TravelTarif', Tarif_Code).subscribe((res) => {
      TarifToModifValide = res;
      TarifToModifValide.TravelTarif[0].Valide = 0;
      this.generalService.postDs(res).subscribe((res) => {
        this.getListeTarifReservation();
      });
    });
  }

  updateDataAfterActions() {
    if (this.Tiers_Code)
      this.generalService.rechercheTable2('batfour1').subscribe((res: any) => {
        this.Tiers_RS = res.find(
          (fournisseur) => fournisseur.Tiers_code == this.Tiers_Code
        ).Tiers_RS;
        console.log(this.Tiers_RS);
      });
  }
  output(event) {
    if (event.action == 'clickRow') {
    }
    if (event.action == 'clickBtnHeat') {
      if (event.bouton.name == 'ajouter') {
        this.openDialogAjouterOuModifier(false);
        return;
      }

      if (event.bouton.name == 'majTarif') {
        console.log('aaa');

        if (this.listeTarifs.length != 0) {
          this.openDialogPreviewMajTarif();
        } else
          this.generalService.dialogSuccess(
            'pas de données disponibles !! veuillez filtrer des tarifs',
            false
          );

        return;
      }

      if (event.liste.row) {
        // if(event.bouton.name == "consulter")
        //   this.router.navigate(["grh/reservation",event.liste.row.Travel_Code, "3"])
        // if (event.bouton.name == 'modifier')
        //   this.router.navigate([
        //     'avt/grh/reservation',
        //     event.liste.row.Travel_Code,
        //     '2',
        //   ]);
        if (event.bouton.name == 'modifier') {
          this.modifier(event);
        }
        if (event.bouton.name == 'supprimer') {
          this.supprimer(event);
        }

        if (event.bouton.name == 'dupliquer') {
          this.dupliquer(event);
        }
      } else
        this.generalService.dialogSuccess(
          'Veillez sélectionner une ligne',
          false
        );
    }
    if (event.action == 'dbClick') {
      this.openDialogAjouterOuModifier(event.liste.row, true);
    }
  }

  modifier(event) {
    if (event && event.liste.row) {
      this.openDialogAjouterOuModifier(event.liste.row, true);
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }
  TarifToModifValide;
  supprimer(event) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'deactivate') {
        this.exist = false;
        this.listBtn.forEach((btn) => {
          btn.disabled = true;
        });
        this.generalService
          .getDS('TravelTarif', event.liste.row.Tarif_Code)
          .subscribe((res) => {
            this.TarifToModifValide = res;
            this.TarifToModifValide.TravelTarif[0].Valide = 0;
            this.generalService.postDs(res).subscribe(
              (res) => {
                this.generalService.dialogSuccess(
                  'Cette Tarif est Invalide',
                  true
                );
                this.getListeTarifReservation();
                this.listBtn.forEach((btn) => {
                  btn.disabled = false;
                });
                this.exist = true;
              },
              (error) => {
                this.generalService.dialogSuccess('Tarif encore valide', false);

                this.exist = true;
              }
            );
          });
      }
      if (result == 'supprimer') {
        this.exist = false;
        this.listBtn.forEach((btn) => {
          btn.disabled = true;
        });
        this.generalService
          .delete(event.liste.row.Tarif_Code, 'TravelTarif')
          .subscribe(() => {
            this.generalService.dialogSuccess('Supprimer', true);
            this.getListeTarifReservation();
            this.listBtn.forEach((btn) => {
              btn.disabled = false;
            });
          });
        this.exist = true;
      }
    });
  }

  oldTarif: any = {};
  copyTarif: any = {};
  dupliquer(event) {
    if (event && event.liste.row) {
      console.log(event.liste.row);
      this.generalService
        .getDS('TravelTarif', event.liste.row.Tarif_Code)
        .subscribe((oldTarif: any) => {
          this.oldTarif = oldTarif;
          this.copyTarif = JSON.parse(JSON.stringify(oldTarif));

          this.oldTarif.TravelTarif[0].Valide = 0;
          this.copyTarif.TravelTarif[0].Valide = 1;
          this.copyTarif.TravelTarif[0].Tarif = null;
          this.copyTarif.TravelTarif[0].Tarif_Code =
            this.tarifService.getNextTarifCode(
              this.tarifService.listeAllTarifs
            );
          this.copyTarif.TravelTarif[0].U_timestamp = null;
          this.copyTarif.ApiForm[0].For_Val = null;
        });

      this.generalService.dialog.open(this.frmDupliquate, {
        disableClose: true,
      });
    } else {
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
    }
  }

  onPostDupliquateTarif() {
    console.log(this.oldTarif);
    console.log('copyTarif', this.copyTarif);

    this.generalService.postDs(this.oldTarif).subscribe(
      (res) => {
        this.generalService.dialogSuccess('mise à jour Tarif', true);
        this.listBtn.forEach((btn) => {
          btn.disabled = false;
        });
        this.exist = true;
      },
      (error) => {
        this.generalService.dialogSuccess('Erreur mise à jour Tarif', false);

        this.exist = true;
      }
    );
    this.generalService.postDs(this.copyTarif).subscribe(
      (res) => {
        console.log(res);
        this.generalService.dialogSuccess('mise à jour Tarif', true);
        this.getListeTarifReservation();
        this.listBtn.forEach((btn) => {
          btn.disabled = false;
        });
        this.exist = true;
        this.close();
      },
      (error) => {
        this.generalService.dialogSuccess('erreur mise à jour Tarif', false);

        this.exist = true;
      }
    );
  }

  close() {
    this.generalService.dialog.closeAll();
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      this.listeTarifsPreview = [];
    });
    this.getDsTarif();
  }

  postBloqueTarifs() {
    var listTravelTarif = [];
    console.log(this.listeTarifsPreview);

    listTravelTarif = this.listeTarifsPreview.map((x) => {
      return {
        Tiers_Categorie: x.Tiers_Categorie,
        Tiers_code: x.Tiers_code,
        Valide: x.Valide,
        Date_Deb: x.Date_Deb,
        Date_Fin: x.Date_Fin,
        Type_Tarif: x.Type_Tarif,
        IND_COLL: x.IND_COLL,
        Observation: x.Observation,
        Groupe_Min: x.Groupe_Min,
        Groupe_Max: x.Groupe_Max,
        Accompagnant: x.Accompagnant,
        Tarif_MAJ: 1,
        Guide: x.Guide,
        Chauffeur: x.Chauffeur,
        Tarif: x.Tarif,
        Marge: x.Marge ? x.Marge : null,
        TVA: x.TVA ? x.TVA : null,
        U_timestamp: null,
      };
    });
    this.dsTarif.TravelTarif = listTravelTarif;
    console.log(this.dsTarif);
    this.generalService.postDs(this.dsTarif).subscribe((res) => {
      console.log('tarif enregistrer');
      this.close();
      this.getDsTarif();
      this.generalService.dialogSuccess(
        'Un mise à jour des tarifs a été Enregistrée!',
        true,
        3000
      );
    });
  }

  MultiPostTarifs(listeTarifs) {
    this.listeTarifs.forEach((tarif) => {
      if (tarif.Type_TarifDecoy !== undefined) {
        tarif.Type_Tarif = tarif.Type_TarifDecoy; // Assign the saved value
      } else {
        console.warn('Type_TarifDecoy is undefined for', tarif);
      }
    });
    this.dsTarif.TravelTarif = listeTarifs;
    console.log(this.dsTarif);
    this.generalService.postDs(this.dsTarif).subscribe((res) => {
      this.close();
      this.getDsTarif();
      this.generalService.dialogSuccess(
        'Multi Post des tarifs a été Enregistrée!',
        true,
        3000
      );
    });
  }

  // ! ###############  choose same file many times onChange event ###############
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  ListImportedTarifs: any[] = [];
  tableHeaders: string[] = [];
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.tarifService.readExcelFile(input);

      // Update the local data after reading the file
      setTimeout(() => {
        this.ListImportedTarifs = this.tarifService.ListImportedTarifs;
        this.ListImportedTarifs.forEach((tarif) => {
          tarif.Tarif_Code = this.tarifService.getNextTarifCode([
            ...this.tarifService.listeAllTarifs,
            ...this.ListImportedTarifs,
          ]);
          tarif.U_timestamp = null;
          tarif.Date_Deb = this.datePipe.transform(
            tarif.Date_Deb,
            'dd-MM-yyyy'
          );
          tarif.Date_Fin = this.datePipe.transform(
            tarif.Date_Fin,
            'dd-MM-yyyy'
          );
        });

        if (this.ListImportedTarifs.length > 0) {
          this.tableHeaders = Object.keys(this.ListImportedTarifs[0]);
          this.openDialogPreviewImportedTraifs();
        } else {
          this.tableHeaders = [];
        }
      }, 1000);
    }
  }

  openFileSelection(): void {
    this.fileInput.nativeElement.value = null;
    this.fileInput.nativeElement.click();
  }

  // ! ###############  END: choose same file many times onChange event ###############

  nextCodeTarif;
  getNextTarifCode(listTarif): string {
    // Extract TARIF_CODEs and convert them to numbers

    let codes = listTarif
      .filter((e) => e.Tarif_Code)
      .map((tarif: any) => parseInt(tarif.Tarif_Code, 10));

    if (codes.length == 0) {
      codes = [0];
    }

    // Find the maximum code
    let maxCode = Math.max(...codes);

    let newCode = maxCode + 1;

    // // Ensure uniqueness
    while (codes.includes(newCode)) {
      newCode += 1;
    }

    return newCode.toString();
  }

  removeItemFromImportedList(item) {
    const index = this.ListImportedTarifs.indexOf(item);
    this.ListImportedTarifs.splice(index, 1);
  }
}
